import React from 'react'
import styled from 'styled-components';

const TableCustom = styled.table`
    table {
        border-collapse: collapse;
    }

    td, th {
        border: 2px solid #FFF;
        text-align: left;
        padding: 8px;
    }

    tr {
        background-color: #F9F9F9;
    }
`;

const TableCookie = ({ lang, listCookie }) => {
    return (
        <>
            {listCookie?.length > 0 ? (
                <>
                    <TableCustom className='w-full'>
                        <tr className='bg-[#F9F9F9]'>
                            <th>{lang === 'TH' ? 'ชื่อคุกกี้' : 'Cookie name'}</th>
                            <th>Provider</th>
                            <th>{lang === 'TH' ? 'ระยะเวลา' : 'Expiry'}</th>
                            <th>{lang === 'TH' ? 'รายละเอียด' : 'Cookie Purpose'}</th>
                        </tr>
                        {
                            listCookie?.map((val) => (
                                <tr className='bg-[#F9F9F9]'>
                                    <td>{val?.cookieName || '-'}</td>
                                    <td>{val?.provider || '-'}</td>
                                    <td>{val?.duration || '-'}</td>
                                    <td>{val?.description || '-'}</td>
                                </tr>
                            ))
                        }
                    </TableCustom>
                </>
            ) : (
                <div className='py-3 bg-[#F9F9F9] rounded-md text-center'>
                    {lang === 'EN' ? 'No cookies were found in this cookie category.' : 'ไม่พบคุกกี้ในประเภทคุกกี้นี้'}
                </div>
            )}
        </>
    )
}

export default TableCookie;
